export default __webpack_public_path__ + "static/SR USA - Hoja de Seguridad - Color Caramelo (Polvo)-54b3bc38d011ec52d5f1946466020d98.pdf";